import type {BioIconProps} from './common-types'

export function IconWhatsup({...attributes}: BioIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none" {...attributes}>
      <path
        d="M0.682949 15.9302C0.682199 18.6398 1.3902 21.2856 2.73645 23.6176L0.554199 31.5853L8.7082 29.4473C10.9635 30.6751 13.4904 31.3184 16.0582 31.3186H16.0649C24.5418 31.3186 31.4422 24.4207 31.4458 15.9423C31.4474 11.8339 29.8489 7.97069 26.9447 5.06419C24.041 2.15794 20.1791 0.556562 16.0643 0.554688C7.58645 0.554688 0.686574 7.45219 0.683074 15.9302"
        fill="url(#paint0_linear_6645_43051)"
      />
      <path
        d="M0.13375 15.927C0.132875 18.7341 0.86625 21.4745 2.2605 23.89L0 32.1434L8.44637 29.9287C10.7736 31.1976 13.3939 31.8666 16.0601 31.8676H16.067C24.848 31.8676 31.9963 24.7216 32 15.9397C32.0015 11.6838 30.3455 7.68162 27.3375 4.671C24.3291 1.66075 20.3291 0.00175 16.067 0C7.2845 0 0.13725 7.145 0.13375 15.927ZM5.16375 23.474L4.84837 22.9734C3.52262 20.8654 2.82288 18.4294 2.82387 15.928C2.82675 8.62863 8.76725 2.69 16.072 2.69C19.6095 2.6915 22.934 4.0705 25.4345 6.5725C27.9349 9.07475 29.3108 12.401 29.3099 15.9388C29.3066 23.2381 23.366 29.1775 16.067 29.1775H16.0618C13.6851 29.1763 11.3542 28.538 9.3215 27.3319L8.83775 27.045L3.8255 28.3591L5.16375 23.4739V23.474Z"
        fill="url(#paint1_linear_6645_43051)"
      />
      <path
        d="M12.0847 9.26745C11.7864 8.60458 11.4726 8.5912 11.1889 8.57957C10.9567 8.56957 10.6912 8.57033 10.4259 8.57033C10.1604 8.57033 9.72907 8.6702 9.36445 9.06833C8.99945 9.46683 7.97095 10.4298 7.97095 12.3885C7.97095 14.3472 9.39757 16.2401 9.59645 16.506C9.79557 16.7713 12.3506 20.9193 16.3971 22.5151C19.7601 23.8412 20.4444 23.5774 21.1743 23.5109C21.9043 23.4447 23.5298 22.5482 23.8614 21.6186C24.1933 20.6891 24.1933 19.8923 24.0938 19.7258C23.9943 19.5599 23.7288 19.4603 23.3307 19.2613C22.9324 19.0622 20.9752 18.0991 20.6103 17.9662C20.2453 17.8335 19.9799 17.7672 19.7144 18.1658C19.4489 18.5638 18.6866 19.4603 18.4542 19.7258C18.2221 19.992 17.9897 20.0251 17.5917 19.8259C17.1933 19.6262 15.9112 19.2063 14.3901 17.8502C13.2066 16.7949 12.4076 15.4918 12.1753 15.0932C11.9431 14.6952 12.1504 14.4795 12.3501 14.2811C12.5289 14.1027 12.7483 13.8162 12.9476 13.5838C13.1461 13.3513 13.2123 13.1855 13.3451 12.92C13.4779 12.6542 13.4114 12.4217 13.3121 12.2226C13.2123 12.0235 12.4387 10.0546 12.0847 9.26745Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6645_43051"
          x1="1545.14"
          y1="3103.62"
          x2="1545.14"
          y2="0.554688"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1FAF38" />
          <stop offset="1" stopColor="#60D669" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6645_43051"
          x1="1600"
          y1="3214.34"
          x2="1600"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9F9F9" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  )
}
